/* tslint:disable */
/* eslint-disable */
export enum ComponentName {
  Home = 'HOME',
  Inventories = 'INVENTORIES',
  Transitions = 'TRANSITIONS',
  EnergyTransitionEditor = 'ENERGY_TRANSITION_EDITOR',
  EnergyBalancing = 'ENERGY_BALANCING',
  Interventions = 'INTERVENTIONS',
  InterventionLibraries = 'INTERVENTION_LIBRARIES',
  InvestmentPlan = 'INVESTMENT_PLAN',
  DashboardEmissions = 'DASHBOARD_EMISSIONS',
  DashboardIndicators = 'DASHBOARD_INDICATORS',
  DashboardInterventions = 'DASHBOARD_INTERVENTIONS',
  DashboardTransitions = 'DASHBOARD_TRANSITIONS',
  MultipleScenarios = 'MULTIPLE_SCENARIOS',
  Analytics = 'ANALYTICS',
}
